import React from "react";

const W = 460, H = 160, PL = 34, PR = 8, PT = 8, PB = 22;

export default function MiniLineChart({ labels, values, color }) {
  const max = Math.max(1, ...values);
  const n = values.length;
  const x = (i) => PL + (n <= 1 ? 0 : (i * (W - PL - PR)) / (n - 1));
  const y = (v) => PT + (H - PT - PB) * (1 - v / max);
  const pts = values.map((v, i) => `${x(i)},${y(v)}`).join(" ");
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((t) => Math.round(max * t));
  const step = Math.max(1, Math.ceil(n / 15));

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto">
      {ticks.map((t, i) => (
        <g key={i}>
          <line x1={PL} x2={W - PR} y1={y(t)} y2={y(t)} stroke="#eef0f3" />
          <text x={PL - 4} y={y(t) + 3} fontSize="8" textAnchor="end" fill="#94a3b8">{t}</text>
        </g>
      ))}
      {labels.map((l, i) => (i % step === 0 || i === n - 1) && (
        <text key={i} x={x(i)} y={H - 6} fontSize="7.5" textAnchor="middle" fill="#94a3b8">{l}</text>
      ))}
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
      {values.map((v, i) => (
        <circle key={i} cx={x(i)} cy={y(v)} r="2" fill="#fff" stroke={color} strokeWidth="1.2">
          <title>{`${labels[i]}: ${v}`}</title>
        </circle>
      ))}
    </svg>
  );
}
